export default {
    data() {
        return {
            tableGBoptions: {
                modals: [{
                        modal: "Descargar",
                        icon: "download",
                        title: "Descargar Registro",
                        showFtn: function(value) {
                            if ((value['info_aportes/id_list_mes'] === value['info_afiliacion/mes_periodo'] && value['info_aportes/id_list_ano'] === value['info_afiliacion/ano_periodo'] && value['autorizar'].length === 0) || (value['info_aportes/servicios'] === 2 && value['autorizar'].length === 0) || (value['archivo_plano/id_datos_razon'] !== value['info_afiliacion/id_datos_razon'] && value['archivo_plano/id_list_novedad'] === 3)) { return true }
                            return false;
                        },
                    },
                    {
                        modal: "Anular",
                        icon: "x-circle",
                        variant: 'danger',
                        title: "Anular Registro",
                        showFtn: function(value) {
                            if ((value['periodo/mes'] === value['info_aportes/id_list_mes'] && value['periodo/ano'] === value['info_aportes/id_list_ano'] && value['archivo_plano/id_datos_razon'] === value['info_afiliacion/id_datos_razon'] && value['autorizar'].length === 0) || (value['info_aportes/servicios'] === 2 && value['autorizar'].length === 0)) { return true }
                            return false;
                        },
                    },
                ]
            },

            tableGBSearch: ['info_aportes/documento', 'info_aportes/name', 'datos_asesor/name'],

            tableGBItems: [{
                    thead: { th: 'Documento', sort: null, sortTable: 'info_aportes/documento' },
                    tbody: { td: ['info_aportes/documento', ] }
                },
                {
                    thead: { th: 'Nombre', sort: null, sortTable: 'info_aportes/name' },
                    tbody: { td: ['info_aportes/name'], }
                },
                {
                    thead: { th: 'Razón', },
                    tbody: { td: ['datos_razon/name'], }
                },
                {
                    thead: { th: 'Asesor', },
                    tbody: { td: ['datos_asesor/name'], }
                },
                {
                    thead: { th: 'Periodo', },
                    tbody: { td: ['list_mes/name', 'list_ano/name'], }
                },
                {
                    thead: { th: 'Registro', },
                    tbody: { td: ['info_aportes/id'], link: '/api/pdf/registroaportes', show: { td: 'info_aportes/anulado', compare: 0, else: 'Anulado' } }
                },
                {
                    thead: { th: 'Valor', },
                    tbody: { td: ['info_aportes/valor'] }
                },
                {
                    thead: { th: 'Radicador', },
                    tbody: { td: ['list_users/name'] }
                },
            ],

        }
    },
}